var render = function render(){var _vm=this,_c=_vm._self._c;return _c('plus-order',{attrs:{"otherChannelId":1212121}})
}
var staticRenderFns = []

export { render, staticRenderFns }